var map = {
	"./01.png": 9975,
	"./02.png": 1244,
	"./03.png": 8757,
	"./04.png": 4090,
	"./05.png": 4851,
	"./06.png": 360,
	"./07.png": 3073,
	"./08.png": 3270,
	"./09.png": 2015,
	"./10.png": 4921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 721;